import { render, staticRenderFns } from "./WishSelected.vue?vue&type=template&id=18218954"
import script from "./WishSelected.vue?vue&type=script&lang=js"
export * from "./WishSelected.vue?vue&type=script&lang=js"
import style0 from "./WishSelected.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports